import db from '../db'
import { Licitacion } from '../interfaces'
import { liveQuery } from '../livequery'

// @ts-ignore
export const tenders = liveQuery(db.licitaciones, Licitacion)
export function initialization(interval = 60000*3) {
    // @ts-ignore
    db.licitaciones.clear()
    tenders.init()
    const syncInterval = setInterval(() => {
        let lastUpdate
        tenders.getLastUpdateState().subscribe((r) => lastUpdate = r)
        // @ts-ignore
        if (lastUpdate && Math.abs(Date.now() - lastUpdate.getTime()) >= interval) {
            tenders.sync()
        }
    }, 1000)
    return [syncInterval, () => clearInterval(syncInterval)]
}
export default tenders
tenders.init()
